<div class="bg-theme-pink rounded-xl w-full h-full">
  <div class="content absolute left-0 top-0 w-[100%] hidden p-5">
    <div class="absolute left-0 sm-home:left-60 top-0 w-38 2xs:w-64 md:left-80 lg:left-125 2xl:left-180
    h-29 bg-[url(https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/home/why/card-pink/home-why-blue-cloud.svg)] bg-right-top bg-contain bg-no-repeat">
    </div>
    <div class="absolute top-75 sm-home:top-78 2xl:top-75 left-10 w-[600px] lg:-ml-0 lg:w-[1024px]
        h-30 bg-[url(https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/home/why/card-pink/home-why-yellow-line.svg)] bg-left-bottom bg-contain bg-no-repeat">
    </div>
    <div class="absolute sm-home:ml-[24px] left-4 sm-home:left-80 md:left-95 lg:left-145 2xl:left-164
            top-78  sm-home:top-58 2xl:top-58
            w-48 sm-home:w-35 2xl:w-70
            h-32 sm-home:h-52 bg-center sm-home:bg-center 2xl:bg-center rounded-xl bg-cover bg-no-repeat
            bg-[url(https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/subscription/event-04.webp)]">
    </div>
    <div class="absolute left-4 sm-home:left-10 top-7 2xs:top-12 w-55 xs-home:w-[280px] 2xs:w-96 lg:w-110 2xl:w-140 h-25">
      <h3 class="font-theme-source text-2xl 2xs:text-2xl lg:text-3xl text-theme-black font-bold">Des lieux élégants où tout<br/>peut arriver ! </h3>
      <p class="font-theme-source text-sm xs-home:text-base lg:text-base text-theme-black mt-3 sm-home:mt-5 lg:mt-3 mr-7 xs:mr-2 2xs:mr-5 sm-home:mr-32 lg:mr-12">
        Des établissements spacieux qui privilégient élégance, calme et modernité.
        Une sélection proche de toutes commodités pour te faciliter au maximum la venue et le retour de nos évènements.
      </p>
    </div>
  </div>
</div>
